import React from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "../../lib/theme";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "../ui/dropdown-menu";

const OPTIONS = [
  { value: "light", label: "Light", Icon: Sun },
  { value: "dark", label: "Dark", Icon: Moon },
  { value: "auto", label: "Match system", Icon: Monitor },
];

export default function ThemeToggle({ size = 18, className = "", align = "end" }) {
  const { mode, effective, setTheme } = useTheme();
  const Active = (OPTIONS.find((o) => o.value === mode) || OPTIONS[1]).Icon;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={`inline-flex items-center justify-center w-9 h-9 rounded-md text-ink/70 hover:text-ink hover:bg-raised/60 transition-colors ${className}`}
        aria-label={`Theme: ${mode}`}
        data-testid="theme-toggle"
      >
        <Active size={size} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-44">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-ink/50">
          Theme
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {OPTIONS.map(({ value, label, Icon }) => (
          <DropdownMenuItem
            key={value}
            onSelect={() => setTheme(value)}
            data-testid={`theme-option-${value}`}
            className={`flex items-center gap-2 cursor-pointer ${
              mode === value ? "text-gold" : ""
            }`}
          >
            <Icon size={14} />
            <span className="flex-1">{label}</span>
            {mode === "auto" && value === "auto" && (
              <span className="text-xs text-ink/40">→ {effective}</span>
            )}
            {mode === value && value !== "auto" && (
              <span className="text-xs text-gold">●</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
